import { ajax } from "../../../../../plugins/api";

export const promotion = {
    list: {
        participants: data => ajax.get("admin/promotion/list/participants", data),
        banned: data => ajax.get("admin/promotion/list/banned", data),
        complainants: data => ajax.get("admin/promotion/list/complainants", data)
    },
    auto: {
        list: data => ajax.get("admin/promotion/autopromotion", data),
        destroy: id => ajax.delete(`admin/promotion/autopromotion/${id}`),
        create: data => ajax.post("admin/promotion/autopromotion", data),
        update: (id, data) => ajax.put(`admin/promotion/autopromotion/${id}`, data),
        get: id => ajax.get(`admin/promotion/autopromotion/${id}`)
    },

    user: {
        get: id => ajax.get(`admin/promotion/user/${id}/social`),
        update: (id, data, vmId = null, scope = "form") =>
            ajax.put(`admin/promotion/user/${id}/social`, data, vmId, scope),
        block: (id, data) => ajax.post(`admin/promotion/user/${id}/ban`, data),
        getVkAccountData: (data = {}, vmId = null, scope = "form") =>
            ajax.get("promotion/profile/vk", data, vmId, scope)
    },

    tasks: {
        list: (id, data) => ajax.get(`admin/promotion/user/${id}/tasks`, data),
        updateTask: (id, data) => ajax.put(`admin/promotion/tasks/${id}`, data)
    },

    completedTasks: {
        list: (id, data) => ajax.get(`admin/promotion/user/${id}/tasks/accepted`, data),
        removeComplaint: id => ajax.delete(`admin/promotion/task-complaints/${id}`)
    },

    complaintsFromUser: {
        list: (userId, data) => ajax.get(`admin/promotion/user/${userId}/complaints/from-user`, data),
        removeComplaint: id => ajax.delete(`admin/promotion/task-complaints/${id}`)
    },

    complaintsToUser: {
        list: (id, data) => ajax.get(`admin/promotion/user/${id}/complaints/to-user`, data),
        removeComplaint: id => ajax.delete(`admin/promotion/user-complaints/${id}`)
    },

    complaintsToTasks: {
        list: (id, data) => ajax.get(`admin/promotion/user/${id}/task-complaints`, data)
    },

    complaintsToTask: {
        list: (userId, taskId, data) => ajax.get(`admin/promotion/user/${userId}/task-complaints/${taskId}`, data),
        removeComplaint: taskId => ajax.delete(`admin/promotion/task-complaints/${taskId}`)
    }
};
